
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviseinkhradi() {



  const cardData =
  {
    keyword: 'Cab Service in Kharadi',
    heading: 'AB Ghule Cabs: Cab Service in Kharadi',
    headingDescription: 'Looking for reliable, comfortable, and affordable cab services in Kharadi? AB Ghule Cabs offers excellent taxi services to cater to all your travel needs. Whether you are commuting for work, planning a family outing, or heading to a special event, we provide top-notch transportation to ensure a smooth and hassle-free journey. Our professional drivers and well-maintained vehicles guarantee comfort and safety throughout your ride.',

    top: 'Top Places to Visit in Kharadi with AB Ghule Cabs',

    "topPlaces": [
        {
          title: "Kharadi Lake",
          description: "A serene spot perfect for unwinding, Kharadi Lake offers a peaceful atmosphere for nature lovers. It’s an ideal location for a relaxing stroll or a picnic with family and friends."
        },
        {
          title: "EON Free Zone",
          description: "One of the leading IT hubs in Pune, EON Free Zone is home to several multinational companies. If you're visiting for business, this is a prime spot for corporate meetings and conferences."
        },
        {
          title: "Zensar Technologies Campus",
          description: "Located in the heart of Kharadi, the Zensar Technologies campus is an impressive structure and a prominent business landmark in the area. It also hosts a variety of events and conferences throughout the year."
        },
        {
          title: "Phoenix Market City",
          description: "This massive shopping mall in Kharadi offers a wide range of retail outlets, food courts, and entertainment options. A great place for shopping, dining, and spending quality time with loved ones."
        },
        {
          title: "Kharadi Garden",
          description: "A beautiful garden for relaxation and recreation, Kharadi Garden is a green space with walking paths and playgrounds, making it a perfect place for evening walks and outdoor activities."
        },
        {
          title: "Viman Nagar",
          description: "Located nearby, Viman Nagar offers a variety of shopping, dining, and entertainment options. Explore the vibrant area, which is perfect for leisure activities after a busy day."
        },
        {
          title: "Mundhwa",
          description: "Just a short drive from Kharadi, Mundhwa offers a blend of modern and traditional attractions, including cultural sites, eateries, and quiet retreats for those seeking peace."
        },
        {
          title: "Khadakwasla Dam",
          description: "For nature enthusiasts, Khadakwasla Dam is a beautiful location for picnics, sightseeing, and enjoying the lush greenery. A perfect getaway from the hustle and bustle of the city."
        },
        {
          title: "Osho International Meditation Resort",
          description: "Located a short distance from Kharadi, this international meditation center is an ideal place for those seeking peace and relaxation through guided meditation and therapeutic sessions."
        },
        {
          title: "Fergusson College Road",
          description: "A popular area near Kharadi, Fergusson College Road is filled with educational institutions, cafes, and shopping outlets, offering a lively atmosphere for those looking to explore Pune's culture and vibrancy."
        }
      ],


      services: [
        {
          "name": "Taxi Service in Kharadi",
          description: "AB Ghule Cabs offers reliable and affordable taxi services in Kharadi. Whether it's a local ride or an outstation trip, our well-maintained vehicles and experienced drivers ensure a smooth and comfortable journey. We provide punctual and professional services tailored to your travel needs."
        },
        {
          "name": "Innova Crysta On Rent in Kharadi",
          description: "Rent an Innova Crysta in Kharadi with AB Ghule Cabs. Perfect for family trips, group travel, or business outings, our Innova Crysta vehicles provide comfort and convenience, ensuring a smooth ride every time. Enjoy spacious interiors and a safe, pleasant journey."
        },
        {
          "name": "Tempo Traveller on Rent in Kharadi",
          description: "Looking for a Tempo Traveller on rent in Kharadi? AB Ghule Cabs provides spacious and well-maintained Tempo Travellers for large groups or family outings, making your journey comfortable and enjoyable. Our vehicles are designed to provide ample space for groups and ensure a hassle-free ride."
        },
        {
          "name": "Mini Bus On Rent in Kharadi",
          description: "AB Ghule Cabs offers Mini Bus on rent in Kharadi for group tours, corporate events, or any other travel needs. Our mini buses are well-maintained and provide a comfortable ride for all passengers. We ensure your group travels together smoothly and safely."
        },
        {
          "name": "Mini Bus on Rent for Outstation",
          description: "Planning an outstation trip with a group? Rent a mini bus for your journey from AB Ghule Cabs. We offer well-maintained mini buses for comfortable and safe outstation travel. Our professional drivers ensure timely arrivals and smooth travel."
        },
        {
          "name": "Corporate Taxi Service in Kharadi Pune",
          description: "AB Ghule Cabs provides corporate taxi services in Kharadi Pune. Whether for business meetings, events, or employee transport, we offer reliable and professional taxi services tailored to your corporate needs. Our services are punctual and ensure a comfortable ride for business professionals."
        },
        {
          "name": "Kharadi to Mumbai Cab",
          description: "Travel from Kharadi to Mumbai with AB Ghule Cabs. Our comfortable and affordable cabs ensure a smooth ride for your one-way or round-trip journey, with professional drivers and well-maintained vehicles. We guarantee a timely and comfortable trip to Mumbai."
        },
        {
          "name": "Kharadi to Aurangabad Cab Service",
          description: "Need a cab from Kharadi to Aurangabad? AB Ghule Cabs offers reliable and affordable cab services for your long-distance journey, ensuring a comfortable and hassle-free trip. Our experienced drivers ensure a smooth and timely journey to Aurangabad."
        },
        {
          "name": "Kharadi to Aliya Nagar Cab Service",
          description: "AB Ghule Cabs provides efficient and affordable Kharadi to Aliya Nagar cab services. Our well-maintained vehicles and professional drivers ensure a smooth and safe journey for all passengers. Whether for business or leisure, we ensure a comfortable and timely ride."
        },
        {
          "name": "Ertiga on Rent in Kharadi",
          description: "Rent an Ertiga in Kharadi with AB Ghule Cabs. Ideal for small groups or family trips, our Ertiga vehicles are well-maintained, affordable, and ensure a comfortable and enjoyable journey. Choose our Ertiga for a reliable and convenient travel experience."
        },
        {
          "name": "Swift Dzire on Rent in Kharadi",
          description: "Looking for a Swift Dzire on rent in Kharadi? AB Ghule Cabs offers well-maintained Swift Dzire cars at competitive rates, providing a comfortable and reliable ride for your local or outstation travel. Our vehicles ensure a smooth and hassle-free journey."
        },
        {
          "name": "Corporate Cab Service in Kharadi",
          description: "AB Ghule Cabs offers corporate cab services in Kharadi, Pune. Our services are ideal for business professionals, ensuring timely, comfortable, and efficient travel for your corporate needs. We provide flexible solutions for meetings, events, and employee transport."
        },
        {
          "name": "Monthly Taxi Service in Kharadi",
          description: "AB Ghule Cabs offers monthly taxi services in Kharadi. Our flexible and affordable monthly packages provide reliable and comfortable travel solutions for daily commuting or corporate travel. Enjoy a stress-free, consistent taxi service throughout the month."
        },
        {
          "name": "Book Reliable Cabs in Kharadi - Local & Outstation Taxi",
          description: "AB Ghule Cabs provides reliable cab services in Kharadi for both local and outstation travel. Our well-maintained vehicles and professional drivers ensure that you travel comfortably and safely wherever you need to go. We guarantee timely and efficient service."
        },
        {
          "name": "Kharadi to Nashik Cabs Booking",
          description: "Book your Kharadi to Nashik cab with AB Ghule Cabs. Our affordable and reliable services ensure a smooth and comfortable ride for your journey to Nashik, whether it's for a one-way trip or a round trip. Enjoy a comfortable and hassle-free journey with us."
        },
        {
          "name": "Kharadi to Mumbai Airport Taxi Booking",
          description: "AB Ghule Cabs offers taxi booking services from Kharadi to Mumbai Airport. Enjoy a timely, comfortable, and hassle-free ride to the airport with our experienced drivers and well-maintained vehicles. We ensure that you reach the airport on time and in comfort."
        },
        {
          "name": "Cab Service in Wagholi",
          description: "For a convenient and affordable cab service in Wagholi, AB Ghule Cabs is your trusted choice. Our professional drivers and well-maintained vehicles ensure a smooth and comfortable journey. We provide timely and efficient transportation for all your travel needs."
        },
        {
          "name": "Cab Service in Kharadi Contact Number",
          description: "Contact AB Ghule Cabs at +91 8624029699 for prompt and efficient Cab Service in Kharadi. We ensure a smooth and enjoyable ride for all our customers. Whether you need a taxi for a short trip, airport transfer, or outstation journey, we are always ready to serve you."
        }
      ],

      tableData: [
        ["Taxi Service in Kharadi", "-Innova Crysta On Rent Kharadi"],
        ["Tempo traveller on rent in Kharadi", "-Mini Bus On rent in Kharadi"],
        ["Mini bus on rent for outstation", "-Corporate taxi service in Kharadi Pune"],
        ["Kharadi to Mumbai cab", "-Kharadi to Aurangabad Cab Service"],
        ["Kharadi to Aliya Nagar cab service", "-Ertiga on rent in Kharadi"],
        ["Swift Dzire on rent in Kharadi", "-Corporate Cab Service in Kharadi"],
        ["Monthly taxi service in Kharadi", "-Book Reliable Cabs in Kharadi - Local & Outstation Taxi"],
        ["Kharadi to Nashik cabs booking", "-Kharadi to Mumbai airport taxi booking"],
        ["Cab service in Wagholi", ""]
      ],
      
      whychoose: [
        {
          WhyChooseheading: "Reliable and Professional Service",
          WhyChoosedescription: "At AB Ghule Cabs, we are committed to providing dependable and professional cab services in Kharadi. Our team of skilled and courteous drivers ensures a smooth, comfortable, and safe journey for all passengers."
        },
        {
          WhyChooseheading: "24/7 Availability",
          WhyChoosedescription: "No matter the time of day or night, we offer round-the-clock availability to cater to your travel needs in Kharadi. Whether you need an early morning ride or a late-night pickup, we’re here to assist you at any time."
        },
        {
          WhyChooseheading: "Affordable Rates",
          WhyChoosedescription: "We offer competitive, transparent pricing with no hidden fees, ensuring that you get value for your money. Whether you’re traveling alone or with a group, we have affordable options to fit your budget."
        },
        {
          WhyChooseheading: "Clean and Well-Maintained Fleet",
          WhyChoosedescription: "Our fleet consists of clean, regularly maintained vehicles that meet high safety standards. We offer a variety of vehicles, including sedans, SUVs, and luxury cars, so you can choose the option that best suits your needs."
        },
        {
          WhyChooseheading: "Safe and Comfortable Rides",
          WhyChoosedescription: "Your safety is our priority. All our drivers are background-checked, and our vehicles are equipped with GPS and necessary safety features to ensure a smooth ride through Kharadi and beyond."
        },
        {
          WhyChooseheading: "Easy Booking Process",
          WhyChoosedescription: "Booking a cab with AB Ghule Cabs is quick and easy. You can book a ride through our website, mobile app, or by calling our customer service team directly for immediate assistance."
        },
        {
          WhyChooseheading: "Customer Satisfaction",
          WhyChoosedescription: "We take pride in our high customer satisfaction rate. Our goal is to ensure that every ride with AB Ghule Cabs is a pleasant experience. Our numerous positive reviews reflect our commitment to excellent service."
        }
      ]
      
  
  

  }

 
  
  const faqData = [
    {
        id: 'FAQ1',
        question: 'How can I book a cab in Kharadi with AB Ghule Cabs?',
        answer: 'You can book a cab easily through our website, mobile app, or by calling our customer service helpline for assistance.',
      },
      {
        id: 'FAQ2',
        question: 'Are your drivers experienced and trustworthy?',
        answer: 'Yes, all our drivers are experienced, highly trained, and background-checked to provide you with a safe and pleasant ride.',
      },
      {
        id: 'FAQ3',
        question: 'What types of vehicles are available for booking?',
        answer: 'We offer a range of vehicles including sedans, SUVs, and luxury cars to cater to different preferences and group sizes.',
      },
      {
        id: 'FAQ4',
        question: 'How do I pay for my ride?',
        answer: 'You can pay for your ride using cash, credit/debit cards, or through online payment options available via our mobile app, providing you with flexibility.',
      },
      {
        id: 'FAQ5',
        question: 'Are there any additional charges for waiting or detours?',
        answer: 'Additional charges may apply for waiting times or detours, but we ensure full transparency. You’ll be informed of any extra charges before your ride.',
      },
      {
        id: 'FAQ6',
        question: 'Can I cancel or modify my booking?',
        answer: 'Yes, you can easily modify or cancel your booking through our website or app. If you require assistance, our customer service team is available to help.',
      },
      {
        id: 'FAQ7',
        question: 'Do you offer one-way and round-trip services?',
        answer: 'Yes, AB Ghule Cabs offers both one-way and round-trip services, allowing you to choose the best option for your trip to or from Kharadi.',
      },
      {
        id: 'FAQ8',
        question: 'Is AB Ghule Cabs available for group travel?',
        answer: 'Yes, we provide spacious vehicles for group travel, ensuring your friends, family, or colleagues travel together comfortably and conveniently.',
      },
      {
        id: 'FAQ9',
        question: 'What makes AB Ghule Cabs different from other cab services?',
        answer: 'AB Ghule Cabs is known for its commitment to providing excellent customer service, experienced drivers, affordable pricing, and a wide variety of vehicles. We ensure every ride is safe, comfortable, and personalized for your needs.',
      },
    ];
  const testimonials = [
    {
        id: 1,
        name: 'Mr. Vikram Patil',
        feedback: 'I often travel to Kharadi for work, and AB Ghule Cabs has been my go-to service. The drivers are always punctual, the cars are clean, and the rates are reasonable. Highly recommended!',
        rating: 5,
      },
      {
        id: 2,
        name: 'Ms. Aarti Deshmukh',
        feedback: 'AB Ghule Cabs made my trip to Kharadi stress-free. The booking process was quick, and the driver was friendly and professional. I’ll be using their services again.',
        rating: 5,
      },
    ];
  





  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Cab Service in Kharadi | Reliable & Affordable Cabs</title>
  <meta name="description" content="Book reliable and affordable cab service in Kharadi with AB Ghule Cabs. 24/7 taxi service for local and outstation trips. Call +91 8624029699 for bookings." />
  <meta name="keywords" content="Taxi Service in Kharadi, Innova Crysta On Rent Kharadi, tempo traveller on rent in kharadi, Mini Bus On rent in Kharadi, mini bus on rent for outstation, corporate taxi service in kharadi pune, kharadi to mumbai cab, kharadi to Aurangabad Cab Service, kharadi to aliya nagar cab service, ertiga on rent in kharadi, swift dzire on rent in kharadi, Corporate Cab Service in Kharadi, monthly taxi service in kharadi, Book Reliable Cabs in Kharadi - Local & Outstation Taxi, kharadi to nashik cabs booking, kharadi to mumbai airport taxi booking, cab service in wagholi" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Cab Service in Kharadi | Reliable & Affordable Cabs" />
  <meta property="og:description" content="Book reliable and affordable cab service in Kharadi with AB Ghule Cabs. 24/7 taxi service for local and outstation trips. Call +91 8624029699 for bookings." />
  <meta property="og:image" content="https://abghulecabs.com/images/cab-service-kharadi.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/cab-service-kharadi" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />

  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs - Cab Service in Kharadi",
        description: "Book reliable and affordable cab service in Kharadi with AB Ghule Cabs. 24/7 taxi service for local and outstation trips. Call +91 8624029699 for bookings.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Kharadi, Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411014",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/cab-service-kharadi",
        "logo": "https://abghulecabs.com/images/cab-service-kharadi.jpg",
        "image": "https://abghulecabs.com/images/cab-service-kharadi.jpg",
        "priceRange": "₹1000 - ₹5000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/cab-service-kharadi",
          "priceCurrency": "INR",
          "price": "1000",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.7",
          "reviewCount": "120"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Rajesh P"
            },
            "datePublished": "2024-09-15",
            "reviewBody": "Affordable and reliable cabs. Used them for a corporate event, and the service was excellent."
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Priya M"
            },
            "datePublished": "2024-08-20",
            "reviewBody": "Booked a tempo traveller for a family trip to Nashik. Great service and a smooth ride!"
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Kharadi and Surrounding Areas Taxi Service",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5535",
            "longitude": "73.9487"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/cab-service-kharadi"
        },
        "keywords": "Taxi Service in Kharadi, Innova Crysta On Rent Kharadi, tempo traveller on rent in kharadi, Mini Bus On rent in Kharadi, mini bus on rent for outstation, corporate taxi service in kharadi pune, kharadi to mumbai cab, kharadi to Aurangabad Cab Service, kharadi to aliya nagar cab service, ertiga on rent in kharadi, swift dzire on rent in kharadi, Corporate Cab Service in Kharadi, monthly taxi service in kharadi, Book Reliable Cabs in Kharadi - Local & Outstation Taxi, kharadi to nashik cabs booking, kharadi to mumbai airport taxi booking, cab service in wagholi"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/60.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Cabserviseinkhradi;